import { ApiResult } from 'interfaces/APITypes';

import { makeRequest, mytoverInstance } from './client';

export const getPrivacyPolicy = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/privacy-policy'));
};

export const acceptPrivacyPolicy = async (hash: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/privacy-policy/${hash}/accept`));
};

export const getEULA = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/eula'));
};

export const acceptEULA = async (hash: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post(`/eula/${hash}/accept`));
};

export const getProcessorTerms = async (): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/processor-terms'));
};
